import { compact, findIndex, map } from 'lodash';
import { extractExcerpt, replaceTags, sanitizeHtml, toUUID } from '../../util/transform';
import { DocType } from '../global/Doc.enum';
import Root from '../Root';
import { MessageType } from './Message.enum';
import type { IMessage } from './Message.interface';

export default class Message extends Root implements IMessage {
  idReference: string;
  idLabels: Array<string>;
  type: Array<MessageType>;
  name: string;
  description: string;
  design: string;
  banner: string;
  subject: string;
  content: string;
  action: string;
  url: string;
  cc: string;
  bcc: string;

  getName() {
    return this.name;
  }

  getTypes() {
    const types = map(this.type, (obj) => MessageType.of(obj?.name || obj));
    return types
      .map((t) => t.title)
      .sort()
      .join(', ');
  }

  getExcerpt() {
    return extractExcerpt(replaceTags(this.getContent(), ' '));
  }

  getContent() {
    return this.content;
  }

  hasBanner() {
    return this.banner && this.banner !== '';
  }

  isType(type) {
    const idx = findIndex(this.type, (t) => MessageType.of(t?.name || t).name === type);
    return idx > -1;
  }

  getDesign() {
    if (this.isType(MessageType.email.name) || this.isType(MessageType.marketing_email.name)) {
      switch (this.design) {
        case 't04':
          return 'Contemporary white';
        case 't03':
          return 'Contemporary grey';
        case 't02':
          return 'Modern white';
        case 't01':
        default:
          return 'Modern grey';
      }
    } else {
      return 'N/A';
    }
  }

  static build = (data: IMessage) => new Message(data);
  static blank = () => new Message({ isActive: true });

  /**
   * Constructor
   * @param {IMessage} data
   */
  constructor(data?: IMessage) {
    super(DocType.of('__definition.message'), data);

    this.idReference = toUUID(data?.idReference);
    this.idLabels = compact(map(data?.idLabels, (obj) => toUUID(obj)));
    this.type = map(data?.type, (obj) => MessageType.of(obj?.name || obj));
    this.name = data?.name || '';
    this.description = data?.description || '';
    this.design = data?.design || '';
    this.banner = data?.banner || '';
    this.subject = data?.subject || '';
    this.content = sanitizeHtml(data?.content || '');
    this.action = data?.action || '';
    this.url = data?.url || '';
    this.cc = data?.cc || '';
    this.bcc = data?.bcc || '';
  }
}
